import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import FacebookIcon from '@mui/icons-material/Facebook';
import axios from 'axios';

const Footer = () => {

  const [facebook, setFacebook] = useState('https://www.facebook.com/0xFactory');
  const [twitter, setTwitter] = useState('https://twitter.com/0xFactoryCom');
  const [telegram, setTelegram] = useState('https://t.me/ZeroxFactory');

  const fetchData = async () => {
    try {
      const response = await axios.get('data.json');
      setTelegram(response.data[4].value);
      setTwitter(response.data[5].value);
      setFacebook(response.data[6].value);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
      fetchData();

    }, []);

  return (
    <Box
      sx={{
        backgroundColor: '#0b1e35',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px',
        borderTop: '1px solid #333',
      }}
    >
      {/* Left Side: Copyright Text */}
      <Typography variant="body2" sx={{ fontSize: '14px' }}>
        All Rights Reserved.
      </Typography>

      {/* Right Side: Social Media Links */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <IconButton
          component="a"
          href={twitter}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#fff' }}
        >
          <TwitterIcon />
        </IconButton>
        <IconButton
          component="a"
          href={telegram}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#fff' }}
        >
          <TelegramIcon />
        </IconButton>
        <IconButton
          component="a"
          href={facebook}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#fff' }}
        >
          <FacebookIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer;
